import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { render } from './render';
var imgStyle = { maxWidth: '100%' };
export function renderAnswer(content, skillApi, cardId) {
    var t = render(content, skillApi, cardId);
    if (content.image) {
        return (_jsxs(_Fragment, { children: [t, !content.text ? null : _jsx("br", {}), _jsx("a", { href: content.image, target: "_blank", rel: "noopener noreferrer", children: _jsx("img", { src: content.image, style: imgStyle }) })] }));
    }
    return t;
}
//# sourceMappingURL=renderAnswer.js.map